import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebaseconfig';
import { setDoc, doc } from 'firebase/firestore';
import '../views/styles/AllergenForm.css';

const allergenCategories = {
  gluten: [
    { en: 'Wheat', da: 'Hvede' },
    { en: 'Barley', da: 'Byg' },
    { en: 'Rye', da: 'Rug' },
    { en: 'Oats', da: 'Havre' }
  ],
  mejeri: [
    { en: 'Milk', da: 'Mælk' },
    { en: 'Cheese', da: 'Ost' },
    { en: 'Butter', da: 'Smør' },
    { en: 'Yogurt', da: 'Yoghurt' }
  ],
  soja: [
    { en: 'Soybeans', da: 'Sojabønner' },
    { en: 'Tofu', da: 'Tofu' },
    { en: 'Soy sauce', da: 'Sojasovs' }
  ],
};

function AllergenForm({ existingAllergens = [], existingName = '', onSave }) {
  const [selectedAllergens, setSelectedAllergens] = useState([]);
  const [userName, setUserName] = useState(existingName);

  useEffect(() => {
    setSelectedAllergens(existingAllergens.map(a => `${a.category}:${a.en}`));
  }, [existingAllergens]);

  const handleAllergenChange = (category, item) => {
    const allergenKey = `${category}:${item.en}`;
    setSelectedAllergens((prev) =>
      prev.includes(allergenKey)
        ? prev.filter((a) => a !== allergenKey)
        : [...prev, allergenKey]
    );
  };

  const handleCategoryChange = (category) => {
    const categoryAllergens = allergenCategories[category].map(item => `${category}:${item.en}`);
    const allSelected = categoryAllergens.every(allergen => selectedAllergens.includes(allergen));
    setSelectedAllergens((prev) =>
      allSelected
        ? prev.filter((allergen) => !categoryAllergens.includes(allergen))
        : [...prev, ...categoryAllergens.filter((allergen) => !prev.includes(allergen))]
    );
  };

  const saveAllergensAndName = async () => {
    if (auth.currentUser) {
      const userId = auth.currentUser.uid;
      const formattedAllergens = selectedAllergens.map((key) => {
        const [category, allergenName] = key.split(':');
        const allergen = allergenCategories[category]?.find(item => item.en === allergenName);
        return {
          category,
          en: allergen ? allergen.en : allergenName,
          da: allergen ? allergen.da : ''
        };
      });
      try {
        await setDoc(doc(db, 'users', userId), { 
          allergens: formattedAllergens,
          name: userName
        }, { merge: true });
        onSave(formattedAllergens); // Callback to update parent component
      } catch (error) {
        console.error("Fejl ved gemning af allergener og navn:", error);
      }
    } else {
      console.log("Ingen bruger er logget ind");
    }
  };

  return (
    <div className="allergen-form">
      <h2>Allergene opsætning</h2>
      <div className="user-name">
        <label htmlFor="name">Dit navn:</label>
        <input
          id="name"
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Indtast dit navn"
          className="name-input"
        />
      </div>
      <div className="allergen-categories">
        {Object.keys(allergenCategories).map((category) => (
          <div key={category} className="allergen-category">
            <h3>{category.charAt(0).toUpperCase() + category.slice(1)}</h3>
            <button className="select-all-button" onClick={() => handleCategoryChange(category)}>
              {selectedAllergens.some(a => a.startsWith(`${category}:`)) ? 'Fjern alle' : 'Vælg alle'}
            </button>
            {allergenCategories[category].map((item) => (
              <div key={item.en} className="allergen-item">
                <input
                  type="checkbox"
                  checked={selectedAllergens.includes(`${category}:${item.en}`)}
                  onChange={() => handleAllergenChange(category, item)}
                />
                <label>{item.da}</label>
              </div>
            ))}
          </div>
        ))}
      </div>
      <button className="save-button" onClick={saveAllergensAndName}>Gem</button>
    </div>
  );
}

export default AllergenForm;